// @ts-ignore
import { log } from "./redux/modules/logger/api";
import { EVENT_TAB_CLOSE } from "./redux/modules/logger/constants";
import { makeSimpleId } from "./utils";

const blockerIds = new Set();
export default function setPageCloseBlocker(): () => void {
  const id = makeSimpleId();
  blockerIds.add(id);
  updateWindowHandler();
  return function() {
    blockerIds.delete(id);
    updateWindowHandler();
  };
}

function onBeforeUnload() {
  log(EVENT_TAB_CLOSE, "1", "user is about to close the tab", true);
  return "Files are still uploading. Are you sure you want to cancel upload process?";
}

function updateWindowHandler() {
  if (blockerIds.size) {
    window.onbeforeunload = onBeforeUnload;
  } else {
    window.onbeforeunload = null;
  }
}
